// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorAiProductContent = (client) => ({
    /**
     * `POST /vendor/ai-product-content/staging/:id/approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAiProductContentStagingApprove
     * @source packages/medusa-plugin-ai-product-content/src/api/vendor/ai-product-content/staging/[id]/approve/route.ts
     */
    approveStaging: (id, body, query, headers) => client.fetch(buildPath("/vendor/ai-product-content/staging/:id/approve", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/ai-product-content/generate`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAiProductContentGenerate
     * @source packages/medusa-plugin-ai-product-content/src/api/vendor/ai-product-content/generate/route.ts
     */
    generate: (body, query, headers) => client.fetch("/vendor/ai-product-content/generate", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/ai-product-content/applications/:id/generate`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAiProductContentApplicationGenerate
     * @source packages/medusa-plugin-ai-product-content/src/api/vendor/ai-product-content/applications/[id]/generate/route.ts
     */
    generateApplications: (id, body, query, headers) => client.fetch(buildPath("/vendor/ai-product-content/applications/:id/generate", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/ai-product-content/staging/:id/audit-events`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAiProductContentStagingAuditEvents
     * @source packages/medusa-plugin-ai-product-content/src/api/vendor/ai-product-content/staging/[id]/audit-events/route.ts
     */
    listStagingAuditEvents: (id, query, headers) => client.fetch(buildPath("/vendor/ai-product-content/staging/:id/audit-events", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/ai-product-content/staging/:id/candidates`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAiProductContentStagingCandidates
     * @source packages/medusa-plugin-ai-product-content/src/api/vendor/ai-product-content/staging/[id]/candidates/route.ts
     */
    listStagingCandidates: (id, query, headers) => client.fetch(buildPath("/vendor/ai-product-content/staging/:id/candidates", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/ai-product-content/staging/:id/image-urls`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAiProductContentStagingImageUrls
     * @source packages/medusa-plugin-ai-product-content/src/api/vendor/ai-product-content/staging/[id]/image-urls/route.ts
     */
    listStagingImageUrls: (id, query, headers) => client.fetch(buildPath("/vendor/ai-product-content/staging/:id/image-urls", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/ai-product-content/staging/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAiProductContentStagingReject
     * @source packages/medusa-plugin-ai-product-content/src/api/vendor/ai-product-content/staging/[id]/reject/route.ts
     */
    rejectStaging: (id, body, query, headers) => client.fetch(buildPath("/vendor/ai-product-content/staging/:id/reject", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/ai-product-content/jobs/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAiProductContentGetJob
     * @source packages/medusa-plugin-ai-product-content/src/api/vendor/ai-product-content/jobs/[id]/route.ts
     */
    retrieveJob: (id, query, headers) => client.fetch(buildPath("/vendor/ai-product-content/jobs/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/ai-product-content/staging`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAiProductContentListStaging
     * @source packages/medusa-plugin-ai-product-content/src/api/vendor/ai-product-content/staging/route.ts
     */
    retrieveStaging: (query, headers) => client.fetch("/vendor/ai-product-content/staging", { method: "GET", query, headers }),
    /**
     * `POST /vendor/ai-product-content/staging/bulk-approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAiProductContentStagingBulkApprove
     * @source packages/medusa-plugin-ai-product-content/src/api/vendor/ai-product-content/staging/bulk-approve/route.ts
     */
    updateStagingBulkApprove: (body, query, headers) => client.fetch("/vendor/ai-product-content/staging/bulk-approve", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/ai-product-content/staging/bulk-reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAiProductContentStagingBulkReject
     * @source packages/medusa-plugin-ai-product-content/src/api/vendor/ai-product-content/staging/bulk-reject/route.ts
     */
    updateStagingBulkReject: (body, query, headers) => client.fetch("/vendor/ai-product-content/staging/bulk-reject", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=ai-product-content.js.map